import React from 'react'
import moment from 'moment-timezone'
import { isUndefined } from 'lodash'

export default function TimeComponent(props) {

  const [time, setTime] = React.useState(moment().format('HH:mm:ss'))

  React.useEffect(() => {
    
    let interval = null;
    interval = setInterval(() => {
      setTime(moment().format('HH:mm:ss'))
    }, 1000);
    
    return () => clearInterval(interval);
  },[])

  return (
    <div className='d-flex align-items-center justify-content-center h-100 w-100'><h1 className='m-0' style={{
      color: isUndefined(props.FontColor)?"#fff":`${props.FontColor}`,
      fontSize: isUndefined(props.textSize) ? 50 : props.textSize,
      fontWeight: 700
    }}>{time}</h1></div>
  )
}
